import React from "react";
import { Outlet } from "react-router-dom";
import { PublicLayoutStyled } from "./styles";
import { ILayoutProps } from "./type";

export interface ILandingPageLayoutProps extends ILayoutProps {}

const PublicLayout: React.FunctionComponent<ILandingPageLayoutProps> = ({
  children,
}) => {
  return <PublicLayoutStyled>{children || <Outlet />}</PublicLayoutStyled>;
};

export default PublicLayout;
